var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 76,
    viewBox: "0 0 202 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo outcomeskills__2024 edit kolor 2",
    clipPath: "url(#clip0_4923_7210)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M98.9536 50.4429C93.9399 50.4429 88.9262 52.894 88.9262 58.4804C88.9262 67.5445 101.363 64.3137 101.363 68.1334C101.363 69.41 99.6929 69.8508 98.0195 69.8508C96.181 69.8508 94.7617 69.1731 93.5372 68.0018L88.4179 72.2657C90.7811 74.6082 94.4152 75.4373 97.7257 75.4373C102.838 75.4373 108.737 73.6739 108.737 67.5972C108.737 58.5298 96.2998 61.5204 96.2998 57.9935C96.2998 56.5722 97.7752 56.0327 99.0031 56.0327C100.498 56.0327 101.733 56.5492 102.739 57.5033L107.621 53.4401C105.403 51.2193 102.026 50.4494 98.9569 50.4494L98.9536 50.4429Z",
    fill: "#812A86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M79.1133 45.2974V75.4309H86.487V62.8497V43.093V39.0562L79.1133 45.2974Z",
    fill: "#812A86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M66.5939 75.7103H73.9676V53.871V50.1631L66.5939 56.4043V75.7103Z",
    fill: "#812A86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M61.94 58.3125L54.5663 64.3859V75.605H61.94V58.3125Z",
    fill: "#812A86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M54.5203 51.5449L61.9038 51.5515L61.9104 58.3125L54.5203 51.5449Z",
    fill: "#E71D73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M183.869 27.0704H192.081L201.964 18.7367C200.02 14.0024 195.362 10.6597 189.913 10.6597C182.718 10.6597 176.882 16.4765 176.882 23.6488C176.882 28.314 179.371 32.374 183.077 34.6638L188.17 30.367C186.328 29.8867 184.79 28.6825 183.866 27.0704H183.869ZM189.913 16.6903C192.907 16.6903 195.438 18.5788 196.432 21.2174H183.397C184.391 18.5788 186.923 16.6903 189.916 16.6903H189.913Z",
    fill: "#E71D73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M40.9413 18.1873C40.9413 18.2992 40.9743 18.4045 40.9743 18.5196V18.1577L40.9413 18.1873Z",
    fill: "#812A86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.6228 0.256836C12.4865 0.256836 4.27118 8.44905 4.27118 18.5495C4.27118 27.5214 10.7636 34.9536 19.3123 36.5098L40.9414 18.2172C40.7599 8.27138 32.6436 0.256836 22.6228 0.256836ZM22.6228 30.0219C16.2691 30.0219 11.1167 24.8861 11.1167 18.5528C11.1167 12.2194 16.2691 7.08368 22.6228 7.08368C28.9766 7.08368 34.1289 12.2194 34.1289 18.5528C34.1289 24.8861 28.9766 30.0219 22.6228 30.0219Z",
    fill: "#E71D73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M82.6351 17.9273H76.1229V25.8925C76.1229 28.4489 76.42 30.3176 79.6282 30.3176C80.4171 30.3176 81.9948 30.2189 82.6351 29.63V35.7791C81.0079 36.368 79.1826 36.5161 77.4564 36.5161C72.5219 36.5161 68.7229 34.4993 68.7229 29.2879V17.9273H63.9864V12.025H68.7229V4.94482H76.1229V12.025H82.6351V17.9273Z",
    fill: "#812A86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M160.458 10.0542C157.289 10.0542 154.421 11.3373 152.335 13.41C150.252 11.3373 147.381 10.0542 144.215 10.0542C137.872 10.0542 132.709 15.1998 132.709 21.5233V35.9863H139.687V21.5233C139.687 19.036 141.72 17.0094 144.215 17.0094C146.711 17.0094 148.744 19.036 148.744 21.5233V35.9863H155.929V21.5233C155.929 19.036 157.959 17.0094 160.458 17.0094C162.957 17.0094 164.986 19.036 164.986 21.5233V35.9863H171.964V21.5233C171.964 15.1998 166.802 10.0542 160.458 10.0542Z",
    fill: "#812A86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M118.196 11.0479C111.001 11.0479 105.165 16.8646 105.165 24.0369C105.165 31.2092 111.001 37.026 118.196 37.026C125.392 37.026 131.227 31.2092 131.227 24.0369C131.227 16.8646 125.392 11.0479 118.196 11.0479ZM118.196 30.9921C114.341 30.9921 111.216 27.8764 111.216 24.0337C111.216 20.1909 114.341 17.0752 118.196 17.0752C122.052 17.0752 125.177 20.1909 125.177 24.0337C125.177 27.8764 122.052 30.9921 118.196 30.9921Z",
    fill: "#812A86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M96.422 30.4856C92.5668 30.4856 89.4411 27.3699 89.4411 23.5272C89.4411 19.6844 92.5668 16.5687 96.422 16.5687C97.9337 16.5687 99.3232 17.059 100.465 17.8716L105.165 13.9564C102.848 11.8541 99.7985 10.5381 96.422 10.5381C89.2266 10.5381 83.391 16.3549 83.391 23.5272C83.391 30.6995 89.2266 36.5163 96.422 36.5163C99.6434 36.5163 102.551 35.3088 104.825 33.3776L100.97 28.7649C99.7457 29.8243 98.168 30.4856 96.422 30.4856Z",
    fill: "#812A86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M57.0088 26.4386C57.0088 28.9259 54.9789 30.9526 52.4803 30.9526C49.9817 30.9526 47.9518 28.9259 47.9518 26.4386V12.2585L40.9742 18.1576V26.4386C40.9742 32.7621 46.1364 37.9077 52.477 37.9077C58.8175 37.9077 63.983 32.7621 63.983 26.4386V11.9756H57.0055V26.4386H57.0088Z",
    fill: "#812A86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M19.3153 36.4801C20.3913 36.6775 21.4904 36.8124 22.6258 36.8124C32.7621 36.8124 40.9775 28.6235 40.9775 18.5198C40.9775 18.4046 40.9445 18.2994 40.9445 18.1875L19.3153 36.4801Z",
    fill: "#812A86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M17.4473 64.8863C17.4473 67.344 14.6318 68.5251 12.12 68.5251C10.0175 68.5251 7.94468 67.6664 6.38677 66.2287L0.165039 71.4072C3.42608 74.309 7.28785 75.6053 11.6744 75.6053C18.8764 75.6053 25.1444 71.9139 25.1444 64.1494C25.1444 51.9532 9.0603 56.0328 9.0603 49.6863C9.0603 47.0806 12.0672 46.0969 14.239 46.0969C15.655 46.0969 17.4077 46.5213 18.7114 47.4096L24.7285 42.3989C22.3553 40.4446 19.4871 39.4642 16.4505 39.1582L1.22455 52.0354C2.78906 61.5733 17.4473 58.8294 17.4473 64.8831V64.8863Z",
    fill: "#812A86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M40.9778 18.1577L47.952 12.2554L40.9778 18.1413V18.1577Z",
    fill: "#812A86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M54.5202 75.5228L41.0865 63.524L54.5136 51.5252H43.4927L35.3467 58.8193V38.3979L27.7684 44.8267V75.5228H35.3467V68.2222L43.4993 75.5228H54.5202Z",
    fill: "#812A86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4923_7210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f683ac1bec51bfec2e84963619899fae.svg";
export { ForwardRef as ReactComponent };